import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

interface NotificationPayload {
  vNotificationTitle: string;
  vNotificationBody: string;
  vnotificationRoute?: string;
}

@Injectable({
  providedIn: 'root',
})
export class NotificationService {

  private apiUrl = environment.auth_url;
  toastrTimeOutInSec = environment.toastrTimeOutInSec;

  constructor(private toastr: ToastrService, private http: HttpClient) {}

  showSuccess(message: string, title: string = '') {
    this.toastr.success(title, message, {
      timeOut: this.toastrTimeOutInSec,
      extendedTimeOut: this.toastrTimeOutInSec,
      progressBar: true,
    });
  }

  showError(message: string, title: string = '') {
    this.toastr.error(title, message, {
      timeOut: this.toastrTimeOutInSec,
      extendedTimeOut: this.toastrTimeOutInSec,
      progressBar: true,
    });
  }

  showInfo(message: string, title: string = '') {
    this.toastr.info(title, message, {
      timeOut: this.toastrTimeOutInSec,
      extendedTimeOut: this.toastrTimeOutInSec,
      progressBar: true,
    });
  }

  showWarning(message: string, title: string = '') {
    this.toastr.warning(title, message, {
      timeOut: this.toastrTimeOutInSec,
      extendedTimeOut: this.toastrTimeOutInSec,
      progressBar: true,
    });
  }

  addNotification(payload: NotificationPayload): Observable<any> {
    return this.http.post(`${this.apiUrl}/notification/v1/add-notifications`, payload);
  }
}
